import { InterfaceColor, ColorOutput } from 'fuse_common/src/api/core'

type TotalColor = InterfaceColor | ColorOutput

export const colors: {
  [color in TotalColor]: string
} = {
  YELLOW: '#FDC912',
  PURPLE: '#BD37FD',
  BLUE: '#4383FF',
  TEAL: '#11D1D1',
  GREEN: '#27DC85',
  GREY: '#8e8e93',
  DEFAULT: '', // TODO: idk how to handle this better, need to improve
  ORANGE: '#F8632C',
  WHITE: '#FFFFFF',
  RED: '#FF453A',
}

export const addressColors: { [color in InterfaceColor]: string } = {
  YELLOW: colors.YELLOW,
  PURPLE: colors.PURPLE,
  BLUE: colors.BLUE,
  TEAL: colors.TEAL,
  GREEN: colors.GREEN,
  GREY: colors.GREY,
}

export const userDisallowedColors: InterfaceColor[] = ['GREY']

export const defaultAddressColor: InterfaceColor = 'YELLOW'
